import { Base, base } from "./base"

export type ZIndices = Base

export const zIndices: ZIndices = {
  ...base,
}
